export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-flashlight-line',
      title: 'Instant Service Activation',
      description: 'Our instant automation system delivers your digital support access code to your email immediately upon subscription confirmation.',
      image: 'https://public.readdy.ai/ai/img_res/5434f4ab5f992cbecaff0a4a97815458.jpg'
    },
    {
      icon: 'ri-tools-line',
      title: 'Free Setup Assistance',
      description: 'We provide complimentary remote installation support to help you configure your entertainment system on your device.',
      image: 'https://readdy.ai/api/search-image?query=technical%20support%20specialist%20providing%20remote%20assistance%20for%20device%20setup%20and%20configuration%20with%20laptop%20and%20tools%20in%20professional%20service%20environment%20showing%20expert%20help&width=400&height=300&seq=feat-setup-002&orientation=landscape'
    },
    {
      icon: 'ri-device-line',
      title: 'COMPATIBILITY',
      description: 'Our service is fully compatible with all devices and applications.',
      image: 'https://readdy.ai/api/search-image?query=multiple%20devices%20including%20smart%20tv%20tablet%20smartphone%20and%20laptop%20showing%20cross%20platform%20compatibility%20and%20universal%20device%20support%20with%20clean%20white%20background&width=400&height=300&seq=feat-compat-003&orientation=landscape'
    },
    {
      icon: 'ri-4k-line',
      title: '4K & UHD QUALITY',
      description: 'We help you optimize your devices for the best UHD and 4K quality experience',
      image: 'https://readdy.ai/api/search-image?query=ultra%20high%20definition%204k%20display%20screen%20showing%20crystal%20clear%20image%20quality%20with%20vibrant%20colors%20and%20sharp%20details%20representing%20premium%20uhd%20viewing%20experience&width=400&height=300&seq=feat-4k-004&orientation=landscape'
    },
    {
      icon: 'ri-signal-wifi-line',
      title: 'Seamless Performance, No Technical Issues!',
      description: 'Tired of interruptions during your favorite entertainment? Say goodbye to technical headaches! Our expert configuration ensures a smooth experience every time.',
      image: 'https://readdy.ai/api/search-image?query=strong%20wifi%20signal%20and%20smooth%20streaming%20performance%20with%20no%20buffering%20showing%20stable%20connection%20and%20seamless%20entertainment%20experience%20with%20modern%20router%20technology&width=400&height=300&seq=feat-perf-005&orientation=landscape'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Live Support',
      description: 'Need help? Our customer support is ready 24/7 for fast and responsive assistance. Your satisfaction is our priority!',
      image: 'https://readdy.ai/api/search-image?query=friendly%20customer%20support%20representative%20with%20headset%20providing%2024%207%20live%20assistance%20in%20modern%20call%20center%20with%20professional%20service%20environment%20and%20helpful%20attitude&width=400&height=300&seq=feat-support-006&orientation=landscape'
    }
  ];

  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Goodys Streams 
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our unmatched benefits make us the top pick for everyone. Curious about what sets us apart? Let's dive in!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-full h-48">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6 text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${feature.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
